// enci.devextreme.js
import { debugLog } from './enci.log.js';

export async function initializeEmailEditor() {
  debugLog('Initializing initializeEmailEditor...');
  const module = await import('./enci.htmleditor.js');
  await module.initializeEmailEditor();
}

export async function initializeSidebar() {
  debugLog('Initializing Admin for Portal...');
  const module = await import('./enci.sidebar.js');
  await module.initializeSidebar();
}
